export function DigitalScoreRing({ score, size = 64 }) {
  const tier = score >= 4 ? 'active' : score >= 2 ? 'partial' : 'invisible';
  const colors = { active: '#1A4D3A', partial: '#B45309', invisible: '#DC2626' };
  const labels = { active: 'Digitally Active', partial: 'Partially Visible', invisible: 'Digitally Invisible' };
  const color = colors[tier];
  const r = (size - 8) / 2;
  const circ = 2 * Math.PI * r;
  const progress = (score / 5) * circ;

  return (
    <div className="flex flex-col items-center gap-1" data-testid="digital-score-ring">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={`${color}20`} strokeWidth="4" />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth="4" strokeDasharray={circ} strokeDashoffset={circ - progress} strokeLinecap="round" transform={`rotate(-90 ${size/2} ${size/2})`} style={{ transition: 'stroke-dashoffset 0.6s ease-out' }} />
        <text x={size/2} y={size/2} textAnchor="middle" dominantBaseline="central" fill={color} fontFamily="Inter, sans-serif" fontWeight="800" fontSize={size * 0.35}>
          {score}
        </text>
      </svg>
      <div className="flex gap-0.5">
        {[0,1,2,3,4].map(i => (
          <div key={i} className="w-1.5 h-1.5 rounded-full" style={{ background: i < score ? color : `${color}30` }} />
        ))}
      </div>
      <span className="font-body text-[10px] uppercase tracking-wider" style={{ color }}>{labels[tier]}</span>
    </div>
  );
}

export function DigitalTierBadge({ tier }) {
  const config = {
    'Digitally Active': { bg: 'bg-status-green/10', text: 'text-status-green', border: 'border-status-green/20', icon: '\u2713' },
    'Partially Visible': { bg: 'bg-status-amber/10', text: 'text-status-amber', border: 'border-status-amber/20', icon: '\u25D0' },
    'Digitally Invisible': { bg: 'bg-status-red/10', text: 'text-status-red', border: 'border-status-red/20', icon: '\u2717' },
  };
  const c = config[tier] || config['Digitally Invisible'];
  return (
    <span data-testid="digital-tier-badge" className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-[4px] font-body text-xs uppercase tracking-wider border ${c.bg} ${c.text} ${c.border}`}>
      <span>{c.icon}</span> {tier}
    </span>
  );
}
